module.exports = __webpack_public_path__ + "static/img/home_img_sgsx_sj.37f3075.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_img_sgsx_sj.png
// module id = 9/6r
// module chunks = 11